<template>
  <v-snackbar v-model="show" :timeout="timeout" :color="color" location="top right" elevation="10">
    {{ message }}
    <template v-if="action" #actions>
      <v-btn variant="text" @click="handleAction">
        {{ action.label }}
      </v-btn>
    </template>
    <template v-else #actions>
      <v-icon @click="show = false">mdi-close</v-icon>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { useToast } from '../../composables/useToast'

const { show, message, color, timeout, action } = useToast()

function handleAction() {
  if (action.value) {
    action.value.handler()
    show.value = false
  }
}
</script>
